var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 8.048a8.001 8.001 0 1 0-9.25 7.9V10.36H4.719V8.048H6.75V6.285a2.822 2.822 0 0 1 3.021-3.112q.901.012 1.791.156V5.3h-1.008a1.155 1.155 0 0 0-1.3 1.25v1.5h2.219l-.355 2.312H9.25v5.591A8 8 0 0 0 16 8.048"
  })));
};
export default SvgFacebook;